import { getEnvVariable } from './env';

const DEFAULT_APP_VERSION = 'dev';

export const getAppVersion = () => {
    const storeVersion = getEnvVariable('NEXT_PUBLIC_STORE_VERSION');
    const sharedUiVersion = getEnvVariable('NEXT_PUBLIC_SHARED_UI_VERSION');
    if (!storeVersion || !sharedUiVersion) {
        return DEFAULT_APP_VERSION;
    }
    const version = storeVersion.replace('HF', '') + sharedUiVersion.replace('HF', '') || '';
    return version ? `v${version}` : DEFAULT_APP_VERSION;
}

export const logAppInfo = () => {
    console.group('Store 2.0');
    console.log('Environment:', getEnvVariable('NEXT_PUBLIC_ENVIRONMENT'));
    console.log('SUIV:', getEnvVariable('NEXT_PUBLIC_SHARED_UI_VERSION'));
    console.log('ICSV:', getEnvVariable('NEXT_PUBLIC_CHECKOUT_SDK_VERSION'));
    console.groupEnd();
};